import { useContext, useEffect } from "react";
import { Context } from "../context/Context";
import Layout from "../layouts/Layout";
import { Helmet, HelmetProvider } from "react-helmet-async";
import "./SettingsPage.css";
import BackupsList from "../components/BackupsList";
import AboutUs from "../components/AboutUs";
import Settings from "../components/Settings";

const SettingPage = () => {
  const { page, setPage, settingsPage } = useContext(Context);

  useEffect(() => {
    setPage({
      name: "تنظیمات",
      slug: "settings",
    });
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <title>تنظیمات</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
          {/* Layout Demo */}
          <div className="col-12 col-md-10 col-lg-8 w-100 h-100 mx-auto">
            <div className="card h-100" style={{ backgroundColor: "#fff0", boxShadow: "none" }}>
              <div className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2">
                <h5>
                  {settingsPage.name !== "" ? settingsPage.name : page.name}
                </h5>
              </div>
              <div className="card-body scrollbar">
                <div className="d-lg-none">
                  <Settings />
                </div>
                {settingsPage.slug == "backup-management" ? (
                  <BackupsList />
                ) : null}

                {/* {settingsPage.slug == "about-us" ? <AboutUs /> : null} */}
              </div>
            </div>
          </div>
          {/*/ Layout Demo */}
        </div>
    </HelmetProvider>
  );
};

export default SettingPage;
